import { ref } from 'vue';
import type { Ref } from 'vue';

import type Map from 'ol/Map';

import { useProvideInjectZoom } from '@/utils/useProvideInject';


export type OlMapWithViewEvents = Pick<Map, 'getPixelFromCoordinate' | 'getSize' | 'getView' | 'on' | 'un'>;


export function useMapZoom(olMap: Ref<OlMapWithViewEvents | null>) {
	const zoom = ref(0);
	useProvideInjectZoom.provideValue(zoom);
	const onZoom = (): void => {
		const mapInstance = olMap.value;
		if (mapInstance == null) {
			return;
		}
		const nextZoom = mapInstance.getView().getZoom();
		if (nextZoom != null) {
			zoom.value = nextZoom;
		}
	};
	return onZoom;
}
